export default {
  repo: 'blog', // required
  owner: 'fouber', // required
  title: 'fouber blog',
  token: '04e8b93ee29f73017d82f01f217e3d#07b261#ebcb', // required. split your access_token with #, create in https://github.com/settings/tokens
  perPage: '15',
  social: [{
    name: 'github',
    url: ''
  }, {
    name: 'weibo',
    url: ''
  }, {
    name: 'twitter',
    url: ''
  }, {
    name: 'wechat',
    url: ''
  }, {
    name: 'instagram',
    url: ''
  }, {
    name: 'facebook',
    url: ''
  }]
}



// WEBPACK FOOTER //
// ./src/config.js